import { useState } from 'react';
import { UserRoles } from '@/enums/enums';
import { createFileRoute } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import useAuth from '@/hooks/use-auth';
import Tabs from '@/components/tabs/tabs-custom';

import { LessonProgramTab } from './-lesson-program-tab';
import { LessonTagsTab } from './-lesson-tags-tab';
import { LessonTypesTab } from './-lesson-types-tab';

const lessonTypeRouteSchema = z.object({
  mode: z.enum(['create', 'update']).optional(),
  type: z.enum(['lesson-type', 'lesson-tag']).optional(),
  lesson_type: z.number().optional(),
  lesson_tag: z.number().optional(),
});

export const Route = createFileRoute('/_app/(lessons)/lessons/settings')({
  validateSearch: zodSearchValidator(lessonTypeRouteSchema),
  component: LessonSettings,
});

function LessonSettings() {
  const { user } = useAuth();
  const { t } = useTranslation('tab');
  const [tab, setTab] = useState('weekly-program');

  const tabs = [
    {
      label: t('lesson_tags'),
      value: 'lesson-tags',
      content: (
        <div className='flex h-full flex-col gap-y-2 px-4 py-2'>
          <LessonTagsTab />
        </div>
      ),
    },
    {
      label: t('weekly_program'),
      value: 'weekly-program',
      content: (
        <div className='flex h-full flex-col gap-y-2 px-4 py-2'>
          <LessonProgramTab />
        </div>
      ),
    },
  ];
  if (user?.role === UserRoles.Root) {
    tabs.push({
      label: t('lesson_types'),
      value: 'lesson-types',
      content: (
        <div className='flex h-full flex-col gap-y-2 px-4 py-2'>
          <LessonTypesTab />
        </div>
      ),
    });
  }
  return <Tabs tab={tab} onChangeTab={setTab} className='pt-4' tabs={tabs} />;
}
